const toastListeners = new Set();
const confirmListeners = new Set();
let toastCounter = 0;
let confirmCounter = 0;

export const toastVariants = {
  info: {
    icon: 'ℹ️',
    className: 'border-sky-200 bg-sky-50 text-slate-800',
    accent: 'text-sky-600',
  },
  success: {
    icon: '✅',
    className: 'border-emerald-200 bg-emerald-50 text-emerald-900',
    accent: 'text-emerald-600',
  },
  warning: {
    icon: '⚠️',
    className: 'border-amber-200 bg-amber-50 text-amber-900',
    accent: 'text-amber-600',
  },
  error: {
    icon: '⛔',
    className: 'border-rose-200 bg-rose-50 text-rose-900',
    accent: 'text-rose-600',
  },
};

export function subscribeToasts(listener) {
  if (typeof listener !== 'function') return () => {};
  toastListeners.add(listener);
  return () => toastListeners.delete(listener);
}

export function showToast({ message, title = '', variant = 'info', duration = 4000 } = {}) {
  if (!message) return null;
  const id = `toast-${Date.now()}-${toastCounter++}`;
  const payload = {
    id,
    message: String(message),
    title: title ? String(title) : '',
    variant,
    duration,
    timestamp: Date.now(),
  };

  if (!toastListeners.size) {
    // eslint-disable-next-line no-console
    console.log(title ? `${title}: ${message}` : message);
    return id;
  }

  toastListeners.forEach((listener) => {
    try {
      listener(payload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Toast listener failed', error);
    }
  });
  return id;
}

export function subscribeConfirms(listener) {
  if (typeof listener !== 'function') return () => {};
  confirmListeners.add(listener);
  return () => confirmListeners.delete(listener);
}

export function showConfirm({
  title = 'Are you sure?',
  message = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'warning',
  destructive = false,
} = {}) {
  return new Promise((resolve) => {
    if (!confirmListeners.size) {
      const result = window.confirm(message || title || '');
      resolve(result);
      return;
    }

    const payload = {
      id: `confirm-${Date.now()}-${confirmCounter++}`,
      title: String(title || ''),
      message: String(message || ''),
      confirmLabel: String(confirmLabel || 'Confirm'),
      cancelLabel: String(cancelLabel || 'Cancel'),
      variant,
      destructive,
      resolve,
    };

    confirmListeners.forEach((listener) => {
      try {
        listener(payload);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Confirm listener failed', error);
      }
    });
  });
}


